<template>
	<div class="left_option">
		<em class="lt_text">{{ name }}</em>
		<span class="int_type half_int" :style="acWidth ? { width: acWidth } : null">
			<!-- <autocomplete ref="ac" :source="list" :credentials="acCredentials" @selected="selectClass" :results-display="formattedDisplay" placeholder="Select Partner Name" /> -->
			<autocomplete ref="ac" :source="selectPartners" :credentials="acCredentials" @selected="selectClass" :results-display="formattedDisplay" placeholder="Select Partner Name" />
		</span>
		<span class="int_type_no_border mgr_5">
			<input type="text" class="tbl_int" v-model.trim="code_string" autocomplete="off" :style="{ width: codeWidth }" @input="update" />
		</span>
	</div>
</template>
<script>
import { apiSelectSimplePartnerList } from '@/api/partner';

export default {
	name: 'SelectPartners',
	props: {
		restrictionOnly: { type: Boolean, default: false },
		customerOnly: {
			type: Boolean,
			default: true,
		},
		vendorOnly: {
			type: Boolean,
			default: false,
		},
		delim: {
			type: String,
			default: ',',
		},
		name: {
			type: String,
			default: 'Partners',
		},
		acWidth: {
			type: String,
			default: null,
		},
		codeWidth: {
			type: String,
			default: '300px',
		},
	},
	data: function() {
		return {
			code_string: null,
			list: [],
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		// #3252 : 응답 시점 세션의 회사를 본다. Vuex 캐시가 아니라 vue-session 값이 기준이다.
		stateScoped: function() {
			var u = this.$session.get('user');
			return !!u && u.company_id === 'beautyplus';
		},
		// 인증 경로로 갈 때만 쿠키를 실어 보낸다. 기존 경로는 종전 동작(same-origin)을 유지한다.
		acCredentials: function() {
			return this.stateScoped ? 'include' : 'same-origin';
		},
	},
	methods: {
		selectPartners(input) {
			// #3252 : beautyplus 는 조회자별 State 제한이 걸리므로 세션을 쓰는 인증 경로로 간다.
			// 기존 acPartnerList 는 인증 예외라 조회자를 알 수 없다. 다른 회사는 종전 경로 그대로다.
			var url = this.stateScoped ? process.env.VUE_APP_API_URL + '/api/partner/acPartnerListAuth?keyword=' + input : process.env.VUE_APP_API_URL + '/api/partner/acPartnerList?company_id=' + this.user.company_id + '&keyword=' + input;
			if (this.customerOnly) url += '&customer_only=true';
			if (this.stateScoped && this.restrictionOnly) url += '&restriction_only=true';
			if (this.vendorOnly) url += '&vendor_only=true';

			return url;
		},
		async apiSelectData() {
			//이건 사용하지 않는게 좋음, 초기 화면 로딩이 오래 걸림
			const param = {
				paging_yn: 'N',
				sort_key: 'name',
				active_yn: 'Y',
			};

			if (this.stateScoped && this.restrictionOnly) param.restriction_only = true;
			if (this.customerOnly) param.customer_only = true;
			if (this.vendorOnly) param.vendor_only = true;

			const { data } = await apiSelectSimplePartnerList(param);
			this.list = data.partnerList;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.code_string) this.code_string += this.delim + c.selectedObject.code;
			else this.code_string = c.selectedObject.code;
			this.update();
		},
		reset() {
			this.code_string = null;
			this.update();
		},
		update() {
			this.$emit('input', this.code_string);
		},
		formattedDisplay(result) {
			return (
				result.code.split('-').reduce(function(t, s) {
					return t + s;
				}) +
				' / ' +
				result.code +
				' / ' +
				result.name
			);
		},
	},
	mounted() {
		//this.apiSelectData();
	},
};
</script>
